/**
 * @pauta/contract — a fronteira entre as duas linguagens.
 *
 * Tudo aqui, exceto este arquivo, e gerado a partir do Pydantic em
 * packages/solver. Editar generated.ts a mao nao adianta: o CI regenera e
 * compara (`pnpm contract:check`).
 *
 * As 19 entidades do contrato. As outras do modelo de dados -- Projeto,
 * Membro, Cenario, Processamento, Classificacao e Regime -- sao da aplicacao
 * e nao aparecem aqui, porque nao mudam a grade que sai do solver.
 *
 * Eram 18 ate `Atribuicao` entrar, quando o motor passou a escolher quem da
 * aula: o que ele decide tem de estar no contrato, por definicao.
 */

export type * from './generated.ts'

import meta from '../schema/meta.json' with { type: 'json' }

/** Versao do contrato, vinda do Pydantic. Viaja nos dois documentos. */
export const VERSAO_CONTRATO: string = meta.versao_contrato

/** Nomes das 19 entidades, na ordem do schema. */
export const ENTIDADES_CONTRATO: readonly string[] = meta.entidades_contrato

/**
 * Campos marcados como dado pessoal, por entidade.
 *
 * E o inventario que torna anonimizacao e exportacao LGPD uma consulta a
 * metadado. A tela de exclusao a pedido da instituicao le daqui; ninguem
 * mantem uma segunda lista a mao.
 */
export const CAMPOS_PESSOAIS: readonly {
  entidade: string
  campo: string
  descricao: string
}[] = meta.campos_pessoais

/**
 * Situacao do registro de criterios de qualidade.
 *
 * `definidos` < `alvo` ate o fim da Fase 1: os 30 itens do URANIA mais os
 * dois do PowerCubus so entram junto com a calibracao contra grades reais.
 */
export const CRITERIOS: {
  readonly definidos: number
  readonly alvo: number
  readonly ids: readonly string[]
} = meta.criterios

/**
 * Os 29 Tipos de distribuição do URÂNIA, encodados como dados.
 *
 * Nenhum `if` no solver conhece a letra "D" — o motor lê
 * `DistribuicaoParams`. É o que permite a escola criar o próprio padrão sem
 * esperar release.
 */
export const PRESETS: {
  readonly total: number
  readonly simbolos: readonly string[]
} = meta.presets
